import {useIsMobileScreen} from '@frontend/hooks/useIsMobileScreen'
import {PromoCards} from '@frontend/modules/layout/promo_cards/PromoCards'
import {AdCategoryFiltersCard} from './AdCategoryFiltersCard'

interface Props {
    services?: boolean
}

// Панель фильтрации на больших экранах.
export function AdsCategoryFiltersPanelTabletAndDesktop(props: Props) {

    const isMobile = useIsMobileScreen()

    const {
        services,
    } = props

    if (isMobile) {
        return null
    }

    return (
        <div
            id="offered-items-sidebar-left"
            className="me-4 flex-shrink-0"
        >
            <AdCategoryFiltersCard services={services} />
            <PromoCards
                className="mt-4"
                utmSource="search_page"
            />
        </div>
    )
}
